export default "__VITE_ASSET__$OF9dmPA__"